module.exports = __webpack_public_path__ + "img/IMG_0419.edae5ba3.png";